import type { NextApiRequest, NextApiResponse } from 'next'
import type { UpdateOrderPayload, UpdateOrderResponse } from 'ecosystem'
import { qliroApi } from 'api'

export const qliroPaymentProvider = async (
  req: NextApiRequest,
  res: NextApiResponse<UpdateOrderResponse | { error: string }>
) => {
  const { qliroPayload }: UpdateOrderPayload = JSON.parse(req.body)

  if (!qliroPayload) {
    res.status(400).json({ error: 'Wrong payload' })
    return
  }

  const { orderId, ...updatedOrder } = qliroPayload

  const { error, data } = await qliroApi.checkout.updateOrder(orderId, updatedOrder)

  if (error) {
    res.status(400).json({ error: error || 'Unknown error' })
    return
  }

  res.status(200).json({ qliroResponse: data } as UpdateOrderResponse)
}
